module.exports = __webpack_public_path__ + "img/array-right-icon.a844e592.svg";